export enum ContentType {
  Moment = "Moment",
  Webinar = "Webinar",
  Trailer = "Trailer",
  Ad = "Ad",
  Misc = "Misc",
  Hub = "Hub",
  FullWidget = "FullWidget"
}
